module.exports = __webpack_public_path__ + "static/media/default_qr_image.467faa26.png";